var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hamburger_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#373E55",
    stroke: "#373E55",
    strokeWidth: 0.5,
    d: "M3.5 3.75a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h17a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75zm0 7a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h17a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75zm0 7a.75.75 0 0 0-.75.75v1c0 .414.336.75.75.75h17a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hamburger_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgHamburger;